import { Link } from "react-router-dom";

// Shared shell for /privacy, /terms, /delete-account.
// Deliberately public — no auth wrapper, no membership required.
export default function LegalLayout({ eyebrow, title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-bone text-ink" data-testid="legal-page">
      {/* Slim top bar — mirrors marketing site aesthetic */}
      <header className="border-b border-ink/10">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between">
          <Link
            to="/"
            className="font-display text-lg tracking-[0.32em] text-ink"
            data-testid="legal-back-home"
          >
            MATCHA·STORY
          </Link>
          <nav className="flex items-center gap-6 text-[10px] uppercase tracking-[0.22em] text-ink-soft">
            <Link to="/privacy" className="hover:text-ink transition-colors" data-testid="legal-nav-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-ink transition-colors" data-testid="legal-nav-terms">Terms</Link>
            <Link to="/delete-account" className="hover:text-ink transition-colors" data-testid="legal-nav-delete">Delete Account</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-20">
        {eyebrow && (
          <p className="overline text-matcha-dark mb-3">{eyebrow}</p>
        )}
        <h1
          className="font-display text-3xl md:text-5xl text-ink mb-3"
          style={{ letterSpacing: "0.02em" }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="font-cormorant italic text-ink-soft text-lg md:text-xl mb-10">
            {subtitle}
          </p>
        )}
        <div className="prose-legal text-ink-soft text-[15px] leading-relaxed space-y-6">
          {children}
        </div>
      </main>

      <footer className="border-t border-ink/10 mt-8">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] uppercase tracking-[0.22em] text-ink-soft">
          <p>© Matcha Story · Progressive Synergy Sdn Bhd</p>
          <p>hello@matchastory.my</p>
        </div>
      </footer>
    </div>
  );
}
